import ClickTracking from '@/share/campaign/click-tracking-mixin'

export default {
  mixins: [ClickTracking],

  props: {
    sharingOptions: {
      type: Object,
      required: true
    }
  },

  computed: {
    channelNameForAnalytics() {
      return 'Bluesky'
    }
  },

  methods: {
    handleClick() {
      const shareClickToken = this.trackEvent()
      const url = this.urlWithShareClickToken(shareClickToken)
      this.openShareBox(url)
    },

    openShareBox(url) {
      window.open(url, 'sharer', 'toolbar=0,status=0,width=626,height=436')
    },

    urlWithShareClickToken(shareClickToken) {
      // First, get the URL we will be sharing, and if applicable, add the share click token to it.
      let campaignUrl = this.sharingOptions.shareUrl
      if (shareClickToken !== null) {
        campaignUrl = campaignUrl + `&share=${shareClickToken}`
      }

      // Then, assemble the text of the Bluesky post, which may contain a message, the URL, and the org's handle.
      let textParts = [campaignUrl]
      if (this.sharingOptions.shareText.length > 0) {
        textParts.unshift(this.sharingOptions.shareText)
      }
      if (this.sharingOptions.orgHandle) {
        textParts.push(`@${this.sharingOptions.orgHandle}`)
      }
      const text = textParts.join(' ')

      // Finally, construct the Bluesky intent-to-share URL.
      const params = new URLSearchParams({ text })
      return `https://bsky.app/intent/compose?${params.toString()}`
    }
  }
}
